<template>
  <div>
      <h1>My informations</h1>

      <div class="alert" v-if="success">
        Profile saved
      </div>
    <form>
      <div class="cols">
        <div>
          <h2>My personal informations</h2>
          <div class="ctrlHolder">
            <label>
              Username
              <input type="text" v-model="client.username" placeholder="username"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Firstname
              <input type="text" v-model="client.firstname" placeholder="firstname"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Lastname
              <input type="text" v-model="client.lastname" placeholder="lastname"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Email
              <input type="text" v-model="client.email" placeholder="email"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Mobile
              <input type="text" v-model="client.mobile" placeholder="mobile"/>
            </label>
          </div>
        </div>
        <div>
          <h2>My Address</h2>
          <div class="ctrlHolder">
            <label>
              Address Line
              <input type="text" v-model="address.addressLine1" placeholder="Address Line"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Postal Code
              <input type="text" v-model="address.postalCode" placeholder="Postal Code"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              City
              <input type="text" v-model="address.city" placeholder="City"/>
            </label>
          </div>
          <div class="ctrlHolder">
            <label>
              Country
              <select v-model="address.country" placeholder="country" name="Country">
                  <option v-for="country in countries" :key="country.id" :value="country.id">{{country.text}}</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </form>
    <div>
      <button class="btn primary" @click="save">Save</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import countryList from '../utils/countries'
export default {
  data: () => ({
    success:false
  }),
  computed:{
    ...mapGetters("auth",["client", "address"]),
    countries () {
      return [...countryList]
    },
  },
  methods:{
    ...mapActions("auth",["updateProfile"]),
    save(){
      this.updateProfile({
        client:this.client,
        address:this.address
      })
      .then(() => {
        this.success = true
      })
    }

  }
}
</script>

<style lang="less">
  .cols{
    display: grid;
    grid-template-columns: repeat(2, minmax(0,1fr));
    grid-column-gap: 40px;
  }
  .ctrlHolder{
    margin-bottom: 1em;
    label{
      input,
      select{
        display: block;
        margin: 5px 0;
      }
    }
  }
</style>